import { Tree, Card } from 'antd';
import { useMemo } from 'react';
import { useMultipleDealerIds } from '../../../../components/contexts/DealerContextManager';
import NoItemResult from '../../../../components/results/NoItemResult';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import { type ApplicationModules } from './ApplicationModuleVehicleAssignments';
import DealerSelectorEmpty from './DealerSelectorEmpty';

export type UpdateFinanceProductAssignmentsValue = {
    dealerFinanceProducts: Record<string, string[]>;
};

export type FinanceProductAssignmentsProps = {
    module: ApplicationModules;
    noItemText: string;
};

const FinanceProductAssignments = ({ module, noItemText }: FinanceProductAssignmentsProps) => {
    const translatedString = useTranslatedString();

    const { dealerIds } = useMultipleDealerIds();

    const treeData = useMemo(
        () =>
            module.dealerFinanceProducts
                .filter(({ dealer }) => dealerIds.includes(dealer.id))
                .map(({ dealer, financeProducts }) => ({
                    key: dealer.id,
                    title: translatedString(dealer.legalName),
                    children: financeProducts.map(financeProduct => ({
                        key: `${dealer.id}-${financeProduct.id}`,
                        title: translatedString(financeProduct.legalName),
                    })),
                })),
        [module, translatedString, dealerIds]
    );

    if (dealerIds.length === 0) {
        return <DealerSelectorEmpty />;
    }

    if (treeData.length === 0) {
        return <NoItemResult subTitle={noItemText} />;
    }

    return (
        <Card>
            <Tree selectable={false} treeData={treeData} defaultExpandAll />
        </Card>
    );
};

export default FinanceProductAssignments;
